import React from "react";
import Classes from "./Features.module.css";
import SparklesIcon from "../../../../../utils/Icons";
import { useNavigate } from "react-router-dom";

// tiny inline SVG icons (match the look; you can replace anytime)
const SearchIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" stroke="#f5b100" strokeWidth="2" />
        <path d="M16 16l5 5" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const SheetIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5" y="3" width="14" height="18" rx="2" stroke="#f5b100" strokeWidth="2" />
        <path d="M8 8h8M8 12h8M8 16h6" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const ListIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 6h10M9 12h10M9 18h10" stroke="#f5b100" strokeWidth="2" strokeLinecap="round" />
        <circle cx="5" cy="6" r="1.5" fill="#f5b100" />
        <circle cx="5" cy="12" r="1.5" fill="#f5b100" />
        <circle cx="5" cy="18" r="1.5" fill="#f5b100" />
    </svg>
);

export default function Features() {
    const navigate = useNavigate();

    return (
        <section id="features" className={`${Classes.features} layoutPadding`}>
            {/* Badge */}
            <div className='badge'>
                <SparklesIcon size={17} color='var(--secondary-color)' />
                Features
            </div>

            {/* Heading + sub */}
            <h2 className='homeTitle'>Why Professionals Choose LightTrack</h2>
            <p className='homeSubTitle'>
                Everything you need to find, compare, and export lighting specifications—streamlined into one simple
                interface built for architectural precision
            </p>

            {/* Cards */}
            <div className={Classes.grid}>
                <article className={Classes.card}>
                    <div className={Classes.cardIcon}><SearchIcon /></div>
                    <h3 className={Classes.cardTitle}>Powerful Fixture Search</h3>
                    <p className={Classes.cardText}>
                        Instantly filter lighting products by specs like beam angle, wattage, and color temperature.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}><SheetIcon /></div>
                    <h3 className={Classes.cardTitle}>Export-Ready Output</h3>
                    <p className={Classes.cardText}>
                        Download spec sheets or Excel files formatted for documentation and team sharing.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}><ListIcon /></div>
                    <h3 className={Classes.cardTitle}>Organized Project Lists</h3>
                    <p className={Classes.cardText}>
                        Save selected fixtures to custom lists and manage them across multiple projects on your account.
                    </p>
                </article>

                <article className={Classes.card}>
                    <div className={Classes.cardIcon}><SparklesIcon size={28} color="#f5b100" /></div>
                    <h3 className={Classes.cardTitle}>Clean, Modern UI</h3>
                    <p className={Classes.cardText}>
                        Work faster with an intuitive, distraction-free interface that puts lighting specs front and center.
                    </p>
                </article>
            </div>

            {/* CTA banner */}
            <div className={Classes.cta}>
                <div className={Classes.ctaLeft}>
                    <h3 className={Classes.ctaTitle}>Start Specifying Smarter <br /> with LightTrack</h3>
                    <p className={Classes.ctaLead}>
                        Explore, compare, and export lighting data—trusted by architects and designers worldwide.
                    </p>
                    <button className={Classes.ctaBtn} onClick={() => { navigate('/signup/customer') }} >
                        Try LightTrack Now <SparklesIcon size={22} color="white" />
                    </button>
                </div>

                <div className={Classes.ctaRight}>
                    <div className={Classes.ctaChip}>Quickly find the exact fixtures you need</div>
                    <div className={Classes.ctaChip}>Save and manage products by project</div>
                    <div className={Classes.ctaChip}>Export clean spec sheets in seconds</div>
                </div>
                <img
                    src="/assets/images/feature-box-bg.png"
                    alt=""
                    aria-hidden="true"
                    className={Classes.authBg}
                    draggable={false}
                />
            </div>
        </section>
    );
}
